import PlotlyChart from './PlotlyChart';
import { COLORS, mergeLayout, mergeConfig } from '../utils/chartTheme';

export default function PieChart({ data, chartOptions = {} }) {
  const labels = data[0].x
  const values = data[0].y

  const traces = [
    {
      labels,
      values,
      type: 'pie',
      hole: 0.45,
      marker: {
        colors: COLORS,
        line: { color: '#ffffff', width: 2 },
      },
      textinfo: 'label+percent',
      textfont: { size: 12, color: '#334155' },
      hovertemplate: '%{label}: %{value} (%{percent})<extra></extra>',
      sort: false,
    }
  ];

  const layout = mergeLayout({
    ...(chartOptions.title ? { title: { text: chartOptions.title, font: { size: 15, color: '#334155' }, x: 0, xanchor: 'left', pad: { l: 4 } } } : {}),
    margin: { t: 24, r: 16, b: 16, l: 16 },
    showlegend: true,
    ...(chartOptions.layout || {}),
  })

  return (
    <PlotlyChart
      data={traces}
      layout={layout}
      config={mergeConfig()}
      style={{ width: '100%', height: '400px' }}
    />
  );
}
